module.exports = __webpack_public_path__ + "static/img/null.8de17e0c.png";